/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useRef } from "react";
import { Table } from "reactstrap";
import { FormattedDate } from "react-intl";
import style from "./Grid.scss";
import CircularProgress from "../../CircularProgress/CircularProgress";
import { StatusBadge, RiskEvolution } from "../Badges";

const Grid = ({ requests, loading, onSelect, hasMore, onLoadMore }) => {
  const sentinelRef = useRef(null);
  const hasRows = !!(requests && requests.length > 0);

  // Auto-load the next page when the bottom sentinel scrolls into view. The
  // parent guards against concurrent fetches (it ignores onLoadMore while a
  // load is in flight), so repeated observer hits are harmless.
  useEffect(() => {
    if (!hasMore || !onLoadMore) return undefined;
    const el = sentinelRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0] && entries[0].isIntersecting) onLoadMore();
      },
      { rootMargin: "200px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, onLoadMore, requests.length]);

  return (
    <div className={`content ${style.desk}`}>
      <Table className={style.table}>
        <thead>
          <tr>
            <th>ID</th>
            <th>Type</th>
            <th>Full Name</th>
            <th>Document</th>
            <th>Created</th>
            <th>Status</th>
            <th>Risk Evolution</th>
            <th>Initiated by</th>
            <th>KYC Due</th>
          </tr>
        </thead>
        <tbody>
          {hasRows ? (
            requests.map((r) => (
              <tr key={`kyc-${r.id}`} onClick={() => onSelect && onSelect(r)}>
                <td>{r.id}</td>
                <td>{r.type}</td>
                <td>{r.fullName}</td>
                <td>
                  {r.documentType && <span className={style.docType}>{r.documentType}</span>}
                  <span className={style.docNumber}>{r.documentNumber}</span>
                </td>
                <td>{r.createdAt ? <FormattedDate value={new Date(r.createdAt)} timeZone="UTC" /> : "—"}</td>
                <td>
                  <StatusBadge value={r.status} />
                </td>
                <td>
                  <RiskEvolution from={r.riskFrom} to={r.riskTo} />
                </td>
                <td>{r.initiatedBy}</td>
                <td>{r.kycDue ? <FormattedDate value={new Date(r.kycDue)} timeZone="UTC" /> : "—"}</td>
              </tr>
            ))
          ) : loading ? (
            <EmptyTable loading />
          ) : (
            <EmptyTable />
          )}
        </tbody>
      </Table>

      {/* Sentinel for infinite scroll — only present while more pages remain. */}
      {hasMore && hasRows && <div ref={sentinelRef} style={{ height: 1 }} />}

      {/* Bottom spinner shown while appending a page (rows already on screen). */}
      {loading && hasRows && (
        <div style={{ textAlign: "center", padding: 16 }}>
          <CircularProgress sm style={{ margin: 0 }} />
        </div>
      )}
    </div>
  );
};

const EmptyTable = ({ loading }) => (
  <tr>
    <td colSpan="9" style={{ textAlign: "center", padding: "60px" }}>
      {loading ? <CircularProgress style={{ marginTop: "10%" }} /> : <h4>No KYC change requests</h4>}
    </td>
  </tr>
);

export default Grid;
